import PropTypes from 'prop-types';
import React from 'react';
import styles from './SVGIcon.module.scss';

const SVGIcon = React.forwardRef((props, ref) => (
  <img
    {...props}
    className={`${props.className} ${props.disabled ? styles.disabled : ''}`}
    src={`/assets/images/icons/misc/${props.name}.svg`}
    ref={ref}
    alt={props.name}
  />
));

SVGIcon.propTypes = {
  name: PropTypes.string.isRequired,
  className: PropTypes.string,
  disabled: PropTypes.bool,
};

SVGIcon.defaultProps = {
  disabled: false,
  className: '',
};

export default SVGIcon;
